import { constants } from '@nhl/formatter-utilities';

import * as StandingsAPI from 'media-base-ui/utils/standingsDataAPI';
import TieBreakingProcedureAPI from 'media-base-ui/utils/tieBreakingProcedureAPI';

import actionCreators from './actionCreators';

const changeCurrentSeason = actionCreators.changeCurrentSeason;

const fetchStandingsData = (season, date) => async dispatch => {
    dispatch(actionCreators.requestStandingsData());

    try {
        const standingsData = await StandingsAPI.fetchStandingsData({date});
        const tieBreakingProcedureData = await TieBreakingProcedureAPI.fetchTieBreakingProcedureForSeason({season})
        dispatch(actionCreators.standingsDataResponse(true, standingsData.data, date.format(constants.DATE_FORMAT), null));
        dispatch(actionCreators.tieBreakingProcedureResponse(true, tieBreakingProcedureData.data?.[0], season, null));
    } catch (error) {
        dispatch(actionCreators.standingsDataResponse(false, {}, date, error))
        dispatch(actionCreators.tieBreakingProcedureResponse(false, {}, season, null));
    }
};

const fetch2020RoundRobinStandingsData = () => async dispatch => {
    dispatch(actionCreators.requestStandingsData());

    try {
        const data = await StandingsAPI.fetch2020RoundRobinStandingsData();
        data.data.forEach(d => {
            // match the shape of team daily standings to make re-use of components easier
            d.teamStats = { conference: d.conference };
        });

        dispatch(actionCreators.standingsDataResponse(true, data.data, 'playoffs', null));
    } catch (error) {
        dispatch(actionCreators.standingsDataResponse(false, {}, 'playoffs', error));
    }
}

export default {
    changeCurrentSeason,
    fetchStandingsData,
    fetch2020RoundRobinStandingsData,
}